export const modalSuccessToastProps = {
  status: "success",
  variant: "subtle",
  duration: 1000,
} as const;
